import Sentry from "@similarweb/sentry-logger";
import type { IDeleteGroupConfirmationModalProps } from "pro-features/components/Modals/src/DeleteGroupConfirmationModal";
import { DeleteGroupConfirmationModal } from "pro-features/components/Modals/src/DeleteGroupConfirmationModal";
import type { FC } from "react";
import { connect } from "react-redux";
import type { ISegmentsData } from "app/services/conversion/ConversionSegmentsService";
import { deleteSegmentData, toggleDeleteSegmentModal } from "app/actions/conversionModuleActions";
import ConversionApiService from "../../../services/conversion/conversionApiService";
import { ConversionSegmentsUtils } from "../ConversionSegmentsUtils";
import { SwTrack } from "app/services/SwTrack";
import { proNavigator } from "single-spa/react-app/ProNavigator";

interface IDeleteSegmentGroupConfirmationProps {
    isOpen: boolean;
    gid?: string;
    toggleDeleteSegmentModal?: (isOpen, gid) => void;
    deleteSegment: (groupId) => void;
    segmentsData: ISegmentsData;
}

const DeleteSegmentGroupConfirmation: FC<IDeleteSegmentGroupConfirmationProps> = ({
    isOpen,
    gid,
    toggleDeleteSegmentModal,
    segmentsData,
    deleteSegment,
}) => {
    const groupData = ConversionSegmentsUtils.getSegmentGroupById(segmentsData, gid);
    const groupname = groupData ? groupData.name : "";
    const conversionApiService = new ConversionApiService();

    const onCancelClick = () => {
        SwTrack.all.trackEvent("Button", "click", `Delete confirmation/Cancel/${gid}`);
        toggleDeleteSegmentModal(false, undefined);
    };

    const onApproveClick = async () => {
        SwTrack.all.trackEvent("Button", "click", `Delete confirmation/Delete/${gid}`);
        try {
            const deletedGroupId = await conversionApiService.deleteSegmentCustomGroup({ gid });
            deleteSegment(deletedGroupId);
            const gidFromParams = proNavigator.getParams().gid;
            if (gid === gidFromParams) {
                window.location.href = proNavigator.getStateUrl("conversion-homepage", {});
            }
            toggleDeleteSegmentModal(false, undefined);
        } catch (error) {
            Sentry.fatal(`Failed to delete user group segment : ${gid}`, error);
        }
    };

    const onCloseClick = () => {
        SwTrack.all.trackEvent("Button", "click", `Delete confirmation/Close/${gid}`);
        toggleDeleteSegmentModal(false, undefined);
    };

    const confirmationModal: IDeleteGroupConfirmationModalProps = {
        onCancelClick,
        onApproveClick,
        onCloseClick,
        isOpen,
        confirmationTitle: "conversion.delete.segment.group.title",
        confirmationSubtitle: "conversion.delete.segment.group.subtitle",
        groupname,
    };
    return <DeleteGroupConfirmationModal {...confirmationModal} />;
};

DeleteSegmentGroupConfirmation.displayName = "DeleteSegmentGroupConfirmation";

function mapDispatchToProps(dispatch) {
    return {
        deleteSegment: (groupId: string) => {
            dispatch(deleteSegmentData(groupId));
        },
        toggleDeleteSegmentModal: (isOpen, gid) => {
            dispatch(toggleDeleteSegmentModal(isOpen, gid));
        },
    };
}

export default connect(undefined, mapDispatchToProps)(DeleteSegmentGroupConfirmation);
